/**
 * @flow
 */

import type Orchestrator from '../orchestrator';
import { extractId, extractParam } from '../util';

export const clickHandler = (orchestrator: Orchestrator) => (evt: Event) => {
  if (evt.defaultPrevented) { return; }
  if (evt.altKey) { return; }
  if (evt.ctrlKey) { return; }
  if (evt.metaKey) { return; }
  if (evt.shiftKey) { return; }

  let element = evt.target;

  if (element instanceof Element) {
    while (element && !(element instanceof HTMLAnchorElement)) {
      element = element.parentElement;
    }

    if (element instanceof HTMLAnchorElement) {
      if (element.className.indexOf('unii-skip') !== -1) { return; }

      const id: string = extractId(element.href);

      if (!id) {
        return;
      }

      const locale: string = extractParam(element.href, 'locale');
      const buttonColor: string = extractParam(element.href, 'buttonColor');
      const buttonText: string = extractParam(element.href, 'buttonText');
      const accessKeys: Array<string> = [extractParam(element.href, 'unii-access-key')].filter(i => i);
      const widgetTimeSlotIds = [extractParam(element.href, 'widgetTimeSlotIds')].filter(i => i);
      const widgetTicketTypes = [extractParam(element.href, 'widgetTicketTypes')].filter(i => i);
      const lang: string = extractParam(element.href, 'lang') || extractParam(element.href, 'locale') || extractParam(element.href, 'l');

      evt.preventDefault();
      orchestrator.showCheckout(id, {
        locale,
        buttonColor,
        buttonText,
        accessKeys,
        widgetTicketTypes,
        widgetTimeSlotIds,
        lang
      });
    }
  }
};

export default function addClickHandler(orchestrator: Orchestrator) {
  document.addEventListener('click', clickHandler(orchestrator));
}



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/addClickHandler.js